const CRUDLStyles = {
    selectedEntityColor: '#e5ffe7',
    filterAppliedColor: '#e9f7ff',
}

export default CRUDLStyles;